<template>
  <!-- Edit Dialog -->
  <base-dialog
    v-model="dialog.show"
    max-width="700px"
    min-width="300px"
    scrollable
    @close="onDialogClose"
    :title="`${titleDialog} ${$t('sidebar.layer-group.name')}`"
    width="50%"
  >
    <base-form ref="form" lazy-validation @submit.stop="onSubmit">
      <v-row no-gutters>
        <v-col cols="12">
          <field-group
            v-model="dialog.data.name"
            autofocus
            :error-messages="dialog.error.name"
            filled
            :label="$t('layergroup.form.name')"
            no-label
          ></field-group>
        </v-col>
        <!-- <v-col cols="12">
          <field-group
            v-model="dialog.data.title"
            :error-messages="dialog.error.title"
            filled
            :label="$t('layergroup.form.title')"
            no-label
          ></field-group>
        </v-col> -->
        <v-col cols="12">
          <field-group
            v-model="dialog.data.srs"
            :error-messages="dialog.error.srs"
            filled
            :label="$t('layergroup.form.projection')"
            no-label
            disabled
          ></field-group>
          <field-group
            :label="$t('layergroup.form.projection')"
            v-model="dialog.data.srs"
            :items="srs.items"
            :loading="srs.loading"
            item-text="name"
            item-value="name"
            filled
            no-label
            :error-messages="dialog.error.srs"
            typeInput="v-autocomplete"
          >
          </field-group>
        </v-col>
        <v-col cols="12">
          <field-group filled :label="$t('layergroup.form.extent')">
            <template #input>
              <v-row>
                <v-col cols="3">
                  <field-group
                    v-model="dialog.data.minx"
                    :error-messages="dialog.error.minx"
                    filled
                    :label="$t('layergroup.form.south')"
                    no-label
                    type="number"
                  ></field-group>
                </v-col>
                <v-col cols="3">
                  <field-group
                    v-model="dialog.data.miny"
                    :error-messages="dialog.error.miny"
                    filled
                    :label="$t('layergroup.form.west')"
                    no-label
                    type="number"
                  ></field-group>
                </v-col>
                <v-col cols="3">
                  <field-group
                    v-model="dialog.data.maxx"
                    :error-messages="dialog.error.maxx"
                    filled
                    :label="$t('layergroup.form.east')"
                    no-label
                    type="number"
                  ></field-group>
                </v-col>
                <v-col cols="3">
                  <field-group
                    v-model="dialog.data.maxy"
                    :error-messages="dialog.error.maxy"
                    filled
                    :label="$t('layergroup.form.north')"
                    no-label
                    type="number"
                  ></field-group>
                </v-col>
              </v-row>
            </template>
          </field-group>
        </v-col>
        <v-col cols="12">
          <field-group
            v-model="dialog.data.abstractTxt"
            autofocus
            :error-messages="dialog.error.abstractTxt"
            filled
            :label="$t('layergroup.form.abstractTxt')"
            no-label
            typeInput="v-textarea"
          >
          </field-group>
        </v-col>
        <v-col cols="12">
          <LayerGroupLayerList v-model="dialog.data.layers" />
        </v-col>
      </v-row>
    </base-form>
    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :loading="dialog.loading"
        outlined
        :type-action="dialog.type"
        @click="onSubmit"
      >
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import LayerGroupLayerList from '@views/layer-group/layer-group-layer-list.vue'
import { EDIT_TYPE } from '@constant'
import { API_LAYERGROUP, API_SRS } from '@api'
import { mapGetters } from 'vuex'
export default {
  components: { LayerGroupLayerList },
  props: {
    datastore_id: {
      type: [String, Number],
    },
  },
  data: () => ({
    dialog: {
      show: false,
      loading: false,
      data: {},
      type: EDIT_TYPE.CREATE,
      error: {},
    },
    layer: {
      items: [],
      loading: false,
      headers: [{ text: 'Name', value: 'name' }],
      value: [],
    },
    default_params: {
      pagination: true,
      itemsPerPage: 5,
      loading: false,
    },
    srs: {
      items: [],
      loading: false,
    },
  }),
  created() {
    this.fetchSrs()
  },
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    titleDialog() {
      if (this.isCreateDialog) {
        return this.$i18n.t('actions.add')
      } else {
        return this.$i18n.t('actions.update')
      }
    },
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
  },
  methods: {
    async open(item, type) {
      if (this.$refs.form) this.$refs.form.resetValidation()
      const res = await API_LAYERGROUP.getDetail(item.id)
      this.dialog.show = true
      this.dialog.type = type
      this.$set(this.dialog, 'data', Object.assign({}, res.data))
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: {},
        type: EDIT_TYPE.CREATE,
        error: {},
      }
    },
    async onSubmit() {
      this.dialog.error = {}
      if (!(await this.$refs.form.validate())) return
      try {
        let data = Object.assign({}, this.dialog.data)
        this.dialog.loading = true
        if (data.layers) {
          data.layer_ids = data.layers.map((x) => x.id)
          data.layers = []
        } else {
          data.layer_ids = []
        }
        let res = await API_LAYERGROUP.update(data.workspace_id, data.id, data)

        if (res && !res.error) {
          this.onDialogClose()
          this.getData()
        }
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.error = response.data.errors
        }
      } finally {
        this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
    fetchSrs() {
      this.srs.loading = true
      API_SRS.list(this.srs.items.params)
        .then((res) => {
          this.srs.items = res.data
        })
        .finally(() => {
          this.srs.loading = false
        })
    },
  },
}
</script>

<style scoped>
.v-btn {
  font-weight: 400;
}
</style>
